import * as React from 'react';
import {
  Link,
  LinkProps,
  useLocation,
  useNavigate,
  NavigateOptions,
  To,
} from 'react-router-dom';

export function useAppNavigate() {
  const navigate = useNavigate();
  return React.useCallback(
    (to: To, opts?: NavigateOptions) => {
      navigate(to, opts);
    },
    [navigate],
  );
}

// ForwardRef so MUI IconButton can attach a ref when used as `component={GuardedLink}`
export const GuardedLink = React.forwardRef<HTMLAnchorElement, LinkProps>(
  function GuardedLinkBase(props, ref) {
    const { to, replace, ...rest } = props as LinkProps & { to: To };
    return <Link ref={ref} to={to} replace={replace} {...rest} />;
  },
);

export function NavigationGuardOnce() {
  const loc = useLocation();
  const lastRef = React.useRef<string>('');

  React.useEffect(() => {
    const key = loc.pathname + loc.search;
    if (key === lastRef.current) return;
    lastRef.current = key;
  }, [loc.pathname, loc.search]);

  return null;
}

